import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/feedback/';

export const getFeedbackArray = async () => await ajax('GET', `${rootUrl}/feedback-types`);

export const sendFeedback = async (payload) =>
  await ajax('POST', `${rootUrl}`, JSON.stringify(payload));
